module.exports = __webpack_public_path__ + "static/media/Snowman.b44e4925.jpg";